<template>
  <div>
    <h1>tag people Demo</h1>
    <div
      style="
        width: 300px;
        height: 300px;
        position: absolute;
        left: 100px;
        top: 200px;
      "
    >
      <tag-group :image="image" style="background: red"></tag-group>
    </div>
  </div>
</template>

<script>
import tagGroup from "../../../components/common/tag/Group";

export default {
  name: "MediaTagDemoPage",
  components: { tagGroup },
  data() {
    return {
      image: { mask: { ratio: 1 }, usertags: [] },
    };
  },
};
</script>

<style lang="less" scoped></style>
